export const topBarHeight: string = '80px';
export const mobileTopBarHeight: string = '80px';
export const mobileBottomBarHeight: string = '70px';
export const sidebarWidth: string = '80px';
